/**
 * Cache key for `GET /user`.
 *
 * Lives outside `src/composables/queries` so auth can read this query without importing
 * a query composable. `query-import/no-new-imports` forbids that import from `src/auth`.
 */
export const userInfoQueryKey = [{ scope: 'user', entity: 'user' }] as const;
